import { connect } from "react-redux";
import { setButtonIsReplyComment, setButtonLimitCommentPost, setHasAskPhoneNumber, setMessageCommentOrder } from "../../../../store/action/settingPageAction";
import SlateEditor from "../../../shared/components/SlateEditor/editor";
import React, { useState } from "react";
import { METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";
import Switch from "../../../shared/components/Button/switch";

const SettingAutoComment = (props) => {
  const { settingPage, setButtonLimitCommentPost, setButtonIsReplyComment, setMessageCommentOrder, setHasAskPhoneNumber } = props;
  const { limit_comment_post, message_comment_order, is_reply_comment, type, has_ask_phone_number } = settingPage;
  const maxComment = 10;
  const [isShowSpam, setIsShowSpam] = useState(false);

  const getListCommentOrder = () => {
    try {
      return JSON.parse(message_comment_order);
    } catch (error) {
      return [];
    }
  }

  const handleAddCommentOrder = () => {
    let array = getListCommentOrder();
    if (array.length < maxComment) {
      array.push('');
      setMessageCommentOrder(JSON.stringify(array));
    }
  }

  const handleRemoveCommentOrder = (index) => {
    let array = getListCommentOrder();
    array.splice(index, 1);
    setMessageCommentOrder(JSON.stringify(array));
  }

  const onChangeCommentOrder = (index, text) => {
    let array = getListCommentOrder();
    array[index] = text;
    setMessageCommentOrder(JSON.stringify(array));
  }

  return (
    <div className="setting-auto-reply-wrapper">
      <div className="card">
        <div className="card-title mb16">
          <span>
            <div className="svg-next-icon card-title-icon ic-library-books">
            </div>
          </span>
          <span>Cài đặt bình luận tự động</span>
        </div>
        <div className="setting-auto-reply-box">
          {
            type === METHOD_TYPE.MANUAL &&
            <div className="setting-auto-reply-row ">
              <div className="switch-setting-item-wrapper">
                <div className="item-group display-flex-align-items-center">
                  <div className="switch-box">
                   <Switch isActived={has_ask_phone_number} onClick={() => setHasAskPhoneNumber(!has_ask_phone_number ? 1 : 0)}/>
                  </div>
                  <div className="info-container">
                    <div className="card-title font-medium text-sm m-none">
                      Tự động hỏi và lưu số điện thoại giao hàng đối với khách hàng mới
                    </div>
                    <span className="card-subtitle text-xs m-none">
                      Thiết lập tự động gửi bình luận hỏi số điện thoại giao hàng đối với khách hàng chưa có thông tin
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="switch-with-input switch-input-has-order">
            <div className="switch-container">
              <div className="switch-wrapper d-flex-center">
                <span>
                  <button type="button" className={`app-switch app-switch-small ${is_reply_comment == 1 ? 'app-switch-checked' : 'app-switch'}`} onClick={() => setButtonIsReplyComment(is_reply_comment == 1 ? 0 : 1)}>
                    <span className="app-switch-inner"></span>
                    <div className="app-click-animating-node">
                    </div>
                  </button>
                </span>
              </div>
              <div className="switch-title-container">
                <div className="switch-title">
                  <div>
                    Bình luận phản hồi khi khách hàng bình luận đúng cú pháp
                  </div>
                </div>
                <div className="switch-subtitle">
                  Tự động gửi bình luận với nội dung ngẫu nhiên theo nhiều mẫu câu để trả lời bình luận của khách hàng.
                </div>
              </div>
              {/* <div className="reset-default-container">
                <span className="livestream-reset-default-button pointer">
                  <div className="svg-next-icon rotate-left ic-fb-menudot">
                  </div>
                </span>
              </div> */}
            </div>
            {is_reply_comment == 1 &&
              <div className="order-comment switch-with-input">
                <div className="app-next-input-checkbox" style={{ marginLeft: 56 }}>
                  <label className="app-next-label--switch" for="app-checkbox-84">
                    Giới hạn phản hồi bình luận cho khách hàng 1 lần trên 1 bài viết
                  </label>
                  <input id="app-checkbox-84" type="checkbox" className="app-next-checkbox" checked={!!limit_comment_post} onChange={() => setButtonLimitCommentPost(limit_comment_post == 1 ? 0 : 1)} />
                  <span className="app-next-checkbox--styled">
                    <span className="app-svg-next-icon app-checkmark" style={{ left: 1, top: 0 }}>
                      <svg className="app-svg-inline-block" width="10px" height="10px" viewBox="0 0 26 26">
                        <path
                          d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z">
                        </path>
                      </svg>
                    </span>
                  </span>
                </div>
                <div className="notice-container rounded-4 d-flex gap-8">
                  <div className="svg-next-icon icon ic-alert-customer">
                  </div>
                  <div className="lh20 d-flex-col gap-4">
                    <div className="title">
                      <b>Lưu ý:</b>
                      Phản hồi bình luận liên tục và hàng loạt trong một khoảng thời gian nhất định có
                      thể dẫn đến việc Facebook hạn chế tài khoản.</div>
                    <div>
                      <div className="color-blue d-inline-flex items-center gap-4 pointer font-medium" onClick={() => setIsShowSpam(!isShowSpam)}>
                        <div>Xem một số lưu ý khi thiết lập nội dung phản hồi để tránh spam</div>
                        <div className={`svg-next-icon icon-expand-more ${isShowSpam && "rotate-180"}`}>
                        </div>
                      </div>
                    </div>
                    {isShowSpam &&
                      <React.Fragment>
                        <div className="d-flex items-center gap-6">
                          <div className="order color-blue d-flex-center font-size-10 line-height-16 font-medium">1</div>
                          <div>Nội dung ngắn gọn, tập trung điều hướng khách hàng về Messenger chốt đơn.</div>
                        </div>
                        <div className="d-flex items-center gap-6">
                          <div className="order color-blue d-flex-center font-size-10 line-height-16 font-medium">2</div>
                          <div>Sử dụng nhiều mẫu kịch bản để đa dạng nội dung phản hồi.</div>
                        </div>
                        <div className="d-flex items-center gap-6">
                          <div className="order color-blue d-flex-center font-size-10 line-height-16 font-medium">3</div>
                          <div>Sử dụng thông tin Họ và Tên, Chi tiết sản phẩm để cá nhân hóa nội dung.</div>
                        </div>
                        <div className="font-semibold">Gợi ý:</div>
                        {/* <div>
                          - Tham khảo các mẫu bình luận
                          <a href="" target="_blank" className="color-blue font-medium">
                            tại đây.
                          </a>
                        </div> */}
                        <div>- Bấm vào nút <span className="icon-more">
                          <div className="svg-next-icon rotate-left ic-fb-menudot" style={{ width: 7, height: 3, maskRepeat: 'no-repeat', maskSize: '7px 3px' }}>
                          </div>
                        </span> để sử dụng nội dung theo gợi ý của hệ thống.</div>
                      </React.Fragment>}
                  </div>
                </div>
                {getListCommentOrder().map((item, index) => (
                  <div>
                    <div className="input-container" key={index}>
                      <div className="input-title">Mẫu câu {index + 1}</div>
                      <div className="input-multi-group">
                        <div style={{ maxWidth: 558 }}>
                          <div className="input-text input-text-none-scrollbar text-multi input-slate editor">
                            <SlateEditor
                              emoji={true}
                              control={true}
                              valueDefault={item}
                              onChange={(text) => onChangeCommentOrder(index, text)}
                              maxLength={640}
                            />
                          </div>
                        </div>
                        <button type="button" className="app-btn app-btn-link app-btn-pd-none ml8 button-remove-input" onClick={() => handleRemoveCommentOrder(index)}>
                          <div className="svg-next-icon icon-remove-input ic-add-outline" >
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {getListCommentOrder().length < maxComment &&
                  <button type="button" className="app-btn app-btn-default button-add-row" onClick={handleAddCommentOrder}>
                    <div className="svg-next-icon mr8 ic-plus-circle-2" >
                    </div>
                    Thêm mẫu câu
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { settingPage } = state;

  return {
    settingPage
  }
}

export default connect(mapStateToProps, {
  setButtonLimitCommentPost,
  setButtonIsReplyComment,
  setMessageCommentOrder,
  setHasAskPhoneNumber
})(SettingAutoComment);